import { MediaLibraryState, mediaLibraryAdapter } from './media-library.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

// Create a feature selector for the 'mediaLibrary' feature
export const selectMediaLibraryState = createFeatureSelector<MediaLibraryState>('mediaLibrary');

const { selectAll } = mediaLibraryAdapter.getSelectors();

// Create a selector to get the files from the state
export const selectMediaLibraryFiles = createSelector(
  selectMediaLibraryState,
  (state) => {
    const files = selectAll(state);
    // Create a copy before sorting to avoid mutating the state
    return [...files].sort((a, b) => b.uploadDate - a.uploadDate);
  }
);

// Media Library Types
export const selectMediaLibraryTypes = createSelector(
  selectMediaLibraryState,
  (state) => state.mediaLibraryTypes
);

// Media Library Quota
export const selectMediaLibraryQuota = createSelector(
  selectMediaLibraryState,
  (state) => state.mediaLibraryQuota
);

export const isMediaLibraryQuotaLoaded = createSelector(
  selectMediaLibraryState,
  (state) => state.mediaLibraryQuotaLoaded
);

export const isMediaLibraryLoaded = createSelector(selectMediaLibraryState, (state) => state.loaded);
export const isMediaLibraryLoadingError = createSelector(selectMediaLibraryState, (state) => state.error);
